export const styles = {
  container: [
    "w-full",
    "p-3",
    "pb-0",
    "sm:p-6",
    "sm:pb-0",
    "mt-10",
    "sm:mt-auto",
    "bg-white",
    "pointer-events-auto",
    "shadow-lg",
    "sm:shadow-none",
    "rounded-xl",
  ].join(" "),
  margin: ["mt-0", " sm:mt-1"].join(" "),
};
